import React, { useState } from 'react';
import { Text } from '@fragments';
import { PLATFORM_ICONS } from '../../enums/platforms';
import './styles.scss';

// A social account's photo, round, with a badge on its bottom edge: the platform on the
// right by default, or another glyph (`badge`, e.g. the personality's identity mark) on either
// side (`badgeSide`: end | start). The photo is the Studio's signed copy (contract
// 1.6.0): when it is null or has expired, the initial takes its place. Decorative: the
// @ next to it carries the name.
export default function SocialAvatar({ picture, label, platform, badge = null, badgeSide = 'end', className = '' }) {
  const url = picture?.url;
  const [failedUrl, setFailedUrl] = useState(null);
  const Badge = badge || PLATFORM_ICONS[platform];
  return <span className={`studio-social-avatar${badgeSide === 'start' ? ' studio-social-avatar--badge-start' : ''} ${className}`.trim()} aria-hidden="true">
    {url && url !== failedUrl
      ? <img src={url} alt="" draggable={false} decoding="async" onError={() => setFailedUrl(url)} />
      : <Text.caption contrast={9}>{(label || '').replace(/^@/, '').trim().charAt(0).toUpperCase()}</Text.caption>}
    {Badge && <span className="studio-social-avatar__platform"><Badge /></span>}
  </span>;
}
